import React, { useEffect, useState } from "react";
import { Form, Input, Select, Breadcrumb } from "antd";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import {
  createTransferRequirement,
  fetchTransferRequirement,
  updateTransferRequirement,
} from "../../../../reduxToolkit/features/transferAcceptanceRequirements/TransferStudentsAcceptanceRequirements";
import ErrorModal from "../../../Components/ErrorModal";

const { Option } = Select;
const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 4,
    span: 16,
  },
};

export default function CreateUpdateTransferStudentsAcceptanceRequirement({
  match,
}) {
  const { t } = useTranslation();
  const { id } = match.params;
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();

  const [openErrorModal, setOpenErrorModal] = React.useState(false);
  const [handledError, setHandledError] = React.useState("");

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  const onFinish = (values) => {
    console.log(values);
    if (id) {
      handleUpdateTransferStudentsAcceptanceRequirement(values);
    } else {
      handleCreateTransferStudentsAcceptanceRequirement(values);
    }
  };
  const onReset = () => {
    form.resetFields();
  };

  useEffect(() => {
    if (id) {
      dispatch(fetchTransferRequirement(id))
        .unwrap()
        .then((req) => {
          form.setFieldsValue({
            code: req.code,
            name: req.name,
          });
        })
        .catch((error) => {
          // handle error here
          setHandledError(error);
          handleOpenErrorModal();
        });
    }
  }, []);

  const { acceptanceRequirement, error } = useSelector(
    (state) => state.transferStudentsAcceptanceRequirement
  );

  const handleCreateTransferStudentsAcceptanceRequirement = async (values) => {
    const resultAction = await dispatch(
      createTransferRequirement({ ...values })
    );
    if (createTransferRequirement.fulfilled.match(resultAction)) {
      // user will have a type signature of User as we passed that as the Returned parameter in createAsyncThunk
      const TransferStudentsAcceptanceRequirement = resultAction.payload;
      //   showToast('success', `Updated ${user.first_name} ${user.last_name}`)
      history.push(
        `/citrine/configuration/program/transferStudentsAccepptanceRequirements`
      );
    } else {
      if (resultAction.payload) {
        // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, those types will be available here.
        console.log(resultAction.payload.field_errors);
        setHandledError(resultAction.payload);
      } else {
        console.log("error", `Update failed: ${resultAction.error}`);
        setHandledError(resultAction.error);
      }
    }
  };

  const handleUpdateTransferStudentsAcceptanceRequirement = async (values) => {
    const resultAction = await dispatch(
      updateTransferRequirement({ id, ...values })
    );
    if (updateTransferRequirement.fulfilled.match(resultAction)) {
      // user will have a type signature of User as we passed that as the Returned parameter in createAsyncThunk
      const TransferStudentsAcceptanceRequirement = resultAction.payload;
      //   showToast('success', `Updated ${user.first_name} ${user.last_name}`)
      history.push(
        `/citrine/configuration/program/transferStudentsAccepptanceRequirements`
      );
    } else {
      if (resultAction.payload) {
        // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, those types will be available here.
        console.log(resultAction.payload.field_errors);
        setHandledError(resultAction.payload);
      } else {
        console.log("error", `Update failed: ${resultAction.error}`);
        setHandledError(resultAction.error);
      }
    }
  };

  return (
    <>
      <Breadcrumb separator=">">
        <Breadcrumb.Item>{t("Configurations")}</Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`/citrine/configuration/program`}>
            <span> {t("program")} </span>
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link
            to={`/citrine/configuration/program/transferStudentsAccepptanceRequirements`}
          >
            {t("Transfer Students Acceptance Requirements")}
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{id ? t("Update") : t("Create")}</Breadcrumb.Item>
      </Breadcrumb>
      <br />

      <Card style={{ padding: "0 30px 0 30px" }}>
        <CardBody>
          <h4>
            <span>
              {" "}
              {id
                ? t("Update Transfer Students Acceptance Requirement")
                : t("Create Transfer Students Acceptance Requirement")}{" "}
            </span>
          </h4>
          <br />
          <Form form={form} name="control-hooks" onFinish={onFinish}>
            <Form.Item
              name="code"
              label="Code"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item>
              <GridContainer justify="flex-end">
                <GridItem>
                  <Button
                    simple
                    color="primary"
                    onClick={() => {
                      history.push(
                        "/citrine/configuration/program/transferStudentsAccepptanceRequirements"
                      );
                    }}
                  >
                    {t("Cancel")}
                  </Button>
                </GridItem>
                <GridItem>
                  <Button type="submit" color="primary">
                    {t("Save")}
                  </Button>
                </GridItem>
              </GridContainer>
            </Form.Item>
          </Form>
        </CardBody>
      </Card>
      {error && (
        <ErrorModal
          open={openErrorModal}
          handleClose={handleCloseErrorModal}
          handledError={handledError}
        />
      )}
    </>
  );
}
